import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import LogonView from '@/views/login/LogonView.vue'
import { isLoggedIn } from '@/utils/userinfo'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'login',
    component: LogonView
  }, {
    path: '/',
    name: 'home',
    component: () => import('@/views/home/HomeView.vue'),
    meta: {
      keepAlive: true
    }
  }, {
    path: '/PersonalVIP',
    name: 'PersonalVIP',
    component: () => import('@/views/personal/PersonalVip.vue')
  }, {
    path: '/PersonalHomepage',
    name: 'PersonalHomepage',
    component: () => import('@/views/personal/UserInfo.vue')
  }, {
    path: '/Wordpractice',
    name: 'Wordpractice',
    component: () => import('@/views/practice/WordpracticeView.vue')
  }, {
    path: '/study',
    name: 'study',
    component: () => import('@/views/practice/StudyView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (!isLoggedIn()) {
    if (to.path == '/login') {
      next()
    } else {
      next('/login')
    }
  } else {
    if (to.path == '/login') {
      next('/')
    } else {
      next()
    }
  }
})

export default router
